<mat-card-content class="mve-detail-popup-container" *ngIf="device">
  <mat-card-header>
    <mat-toolbar color="accent" fxLayoutAlign="space-between center">
      <h2 fxFlex fxLayout="row" fxLayoutAlign="start center">
        {{ device.name }}
        <mat-progress-spinner *ngIf="!configuration" style="margin-left: 20px" mode="indeterminate" [diameter]="20"
                              color="white"></mat-progress-spinner>
      </h2>
    </mat-toolbar>
  </mat-card-header>
  <mat-tab-group *ngIf="configuration" mat-align-tabs="left" mat-stretch-tabs color="accent">
    <mat-tab label="{{'DEVICE_DETAIL.TAB_DATE.TITLE' | translate}}">
      <div fxLayout="row" fxFlex>
        <div style="padding-top: 12px; padding-right: 5px">
          <span class="material-icons">public</span>
        </div>
        <mat-form-field appearance="fill">
          <mat-label>{{'DEVICE_DETAIL.TAB_DATE.TIMEZONE' | translate}}</mat-label>
          <mat-select [(ngModel)]="configuration.timezone" (selectionChange)="onTimezoneChange()">
            <mat-option value="europe">
              {{'DEVICE_DETAIL.TIMEZONE.EUROPE' | translate}}
            </mat-option>
            <mat-option value="nam">
              {{'DEVICE_DETAIL.TIMEZONE.NAM' | translate}}
            </mat-option>
            <mat-option value="usa">
              {{'DEVICE_DETAIL.TIMEZONE.USA' | translate}}
            </mat-option>
            <mat-option value="asia">
              {{'DEVICE_DETAIL.TIMEZONE.ASIA' | translate}}
            </mat-option>
            <mat-option value="pacific">
              {{'DEVICE_DETAIL.TIMEZONE.PACIFIC' | translate}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div fxLayout="row" fxFlex class="master-view-engine-container">
        <div class="table-container">
          <table class="mat-table">
            <thead>
            <tr class="table-row-header mat-header-row">
              <th class="mat-header-cell" [fxLayoutAlign]="'start center'"
                  [fxFlex]="'19%'">{{"DEVICE_DETAIL.TAB_DATE.TITLE" | translate}}</th>
              <th class="mat-header-cell" [fxLayoutAlign]="'center center'"
                  [fxFlex]="'27%'">{{"DEVICE_DETAIL.TAB_DATE.LAST_UPDATE" | translate}}</th>
              <th class="mat-header-cell" [fxLayoutAlign]="'center center'"
                  [fxFlex]="'27%'">{{"DEVICE_DETAIL.TAB_DATE.LAST_READ" | translate}}</th>
              <th class="mat-header-cell" [fxLayoutAlign]="'start center'"
                  [fxFlex]="'27%'">{{"DEVICE_DETAIL.TAB_DATE.NEW_VALUE" | translate}}</th>
              <th><span class="material-icons edited-field-icon">edit</span></th>
            </tr>
            </thead>
            <tbody>
            <tr class="table-row-content">
              <td class="mat-cell" [fxLayoutAlign]="'start center'"
                  [fxFlex]="'19%'">{{'DEVICE_DETAIL.TAB_DATE.CURRENT' | translate}}</td>
              <td class="mat-cell" [fxLayoutAlign]="'center center'"
                  [fxFlex]="'27%'">{{configuration.currentDate.lastUpdateDate | utcDateFormat}}</td>
              <td class="mat-cell" [fxLayoutAlign]="'center center'"
                  [fxFlex]="'27%'">{{ configuration.currentDate.lastValue | utcDateFormat}}</td>
              <td class="mat-cell" [fxLayoutAlign]="'start center'" [fxFlex]="'27%'">
                <mat-form-field>
                  <input [(ngModel)]="configuration.currentDate.value" matInput
                         type="number"
                         (ngModelChange)="onCurrentDateChange($event)"
                         (change)="configuration.currentDate.edit = true" />
                </mat-form-field>
              </td>
              <td class="mat-cell" [fxFlex]="'4%'" [fxLayoutAlign]="'start center'">
                <mat-checkbox [(ngModel)]="configuration.currentDate.edit"
                  (ngModelChange)="onCurrentDateChange(configuration.currentDate.value)"></mat-checkbox>
              </td>
            </tr>
            <tr class="table-row-content">
              <td class="mat-cell" [fxLayoutAlign]="'start center'"
                  [fxFlex]="'19%'">{{'DEVICE_DETAIL.TAB_DATE.NEXT_RECORD' | translate}}</td>
              <td class="mat-cell" [fxLayoutAlign]="'center center'"
                  [fxFlex]="'27%'">{{configuration.nextRecordDate.lastUpdateDate | utcDateFormat}}</td>
              <td class="mat-cell" [fxLayoutAlign]="'center center'"
                  [fxFlex]="'27%'">{{configuration.nextRecordDate.lastValue | utcDateFormat}}</td>
              <td class="mat-cell" [fxLayoutAlign]="'start center'" [fxFlex]="'27%'">
                <app-date-input *ngIf="configuration.timezone !== null"
                  [defaultValue]="configuration.nextRecordDate.defaultValue"
                  (changed)="configuration.nextRecordDate.value = $event"
                  (selectionChange)="configuration.nextRecordDate.edit = true"></app-date-input>
                <span *ngIf="!configuration.timezone">{{"DEVICE_DETAIL.TAB_DATE.CHOOSE_TIMEZONE" | translate}}</span>
              </td>
              <td class="mat-cell" [fxFlex]="'4%'" [fxLayoutAlign]="'start center'">
                <mat-checkbox [(ngModel)]="configuration.nextRecordDate.edit"></mat-checkbox>
              </td>
            </tr>
            <tr class="table-row-content">
              <td class="mat-cell" [fxLayoutAlign]="'start center'"
                  [fxFlex]="'19%'">{{'DEVICE_DETAIL.TAB_DATE.NEXT_SEND' | translate}}</td>
              <td class="mat-cell" [fxLayoutAlign]="'center center'"
                  [fxFlex]="'27%'">{{configuration.nextSendDate.lastUpdateDate | utcDateFormat}}</td>
              <td class="mat-cell" [fxLayoutAlign]="'center center'"
                  [fxFlex]="'27%'">{{configuration.nextSendDate.lastValue | utcDateFormat}}</td>
              <td class="mat-cell" [fxLayoutAlign]="'start center'" [fxFlex]="'27%'">
                <app-date-input *ngIf="configuration.timezone !== null"
                  [defaultValue]="configuration.nextSendDate.defaultValue"
                  (changed)="configuration.nextSendDate.value = $event"
                  (selectionChange)="configuration.nextSendDate.edit = true"></app-date-input>
                <span *ngIf="!configuration.timezone">{{"DEVICE_DETAIL.TAB_DATE.CHOOSE_TIMEZONE" | translate}}</span>
              </td>
              <td class="mat-cell" [fxFlex]="'4%'" [fxLayoutAlign]="'start center'">
                <mat-checkbox [(ngModel)]="configuration.nextSendDate.edit"></mat-checkbox>
              </td>
            </tr>
            <tr class="table-row-content">
              <td class="mat-cell" [fxLayoutAlign]="'start center'"
                  [fxFlex]="'19%'">{{'DEVICE_DETAIL.TAB_DATE.NEXT_DIAGNOSIS' | translate}}</td>
              <td class="mat-cell" [fxLayoutAlign]="'center center'"
                  [fxFlex]="'27%'">{{configuration.nextDiagnosisDate.lastUpdateDate | utcDateFormat}}</td>
              <td class="mat-cell" [fxLayoutAlign]="'center center'"
                  [fxFlex]="'27%'">{{configuration.nextDiagnosisDate.lastValue | utcDateFormat}}</td>
              <td class="mat-cell" [fxLayoutAlign]="'start center'" [fxFlex]="'27%'">
                <app-date-input *ngIf="configuration.timezone !== null"
                  [defaultValue]="configuration.nextDiagnosisDate.defaultValue"
                  (changed)="configuration.nextDiagnosisDate.value = $event"
                  (selectionChange)="configuration.nextDiagnosisDate.edit = true"></app-date-input>
                <span *ngIf="!configuration.timezone">{{"DEVICE_DETAIL.TAB_DATE.CHOOSE_TIMEZONE" | translate}}</span>
              </td>
              <td class="mat-cell" [fxFlex]="'4%'" [fxLayoutAlign]="'start center'">
                <mat-checkbox [(ngModel)]="configuration.nextDiagnosisDate.edit"></mat-checkbox>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </mat-tab>
    <mat-tab *ngFor="let alarm of configuration.alarmThresholds"
             label="{{'DEVICE_DETAIL.TAB_ALARM.TITLE' | translate}} {{alarm.variableName}}">
      <div fxLayout="row" fxFlex class="master-view-engine-container">
        <div class="table-container">
          <table class="mat-table">
            <thead>
            <tr class="table-row-header mat-header-row">
              <th class="mat-header-cell" [fxLayoutAlign]="'start center'"
                  [fxFlex]="'19%'">{{'DEVICE_DETAIL.TAB_ALARM.TITLE' | translate}}</th>
              <th class="mat-header-cell" [fxLayoutAlign]="'center center'"
                  [fxFlex]="'27%'">{{'DEVICE_DETAIL.TAB_ALARM.LAST_UPDATE' | translate}}</th>
              <th class="mat-header-cell" [fxLayoutAlign]="'center center'"
                  [fxFlex]="'27%'">{{'DEVICE_DETAIL.TAB_ALARM.LAST_READ' | translate}}</th>
              <th class="mat-header-cell" [fxLayoutAlign]="'start center'"
                  [fxFlex]="'27%'">{{'DEVICE_DETAIL.TAB_ALARM.NEW_VALUE' | translate}}</th>
              <th><span class="material-icons edited-field-icon">edit</span></th>
            </tr>
            </thead>
            <tbody>
            <tr class="table-row-content">
              <td class="mat-cell" [fxLayoutAlign]="'start center'"
                  [fxFlex]="'19%'">{{'DEVICE_DETAIL.TAB_ALARM.TYPE' | translate}}</td>
              <td class="mat-cell" [fxLayoutAlign]="'center center'"
                  [fxFlex]="'27%'">{{alarm.alarmType.lastUpdateDate | utcDateFormat}}</td>
              <td class="mat-cell" [fxLayoutAlign]="'center center'" [fxFlex]="'27%'">
                <div [ngSwitch]="alarm.alarmType.lastValue">
                  <span *ngSwitchCase="0">{{ 'DEVICE_DETAIL.TYPE.NONE'    | translate }}</span>
                  <span *ngSwitchCase="2">{{ 'DEVICE_DETAIL.TYPE.MIN'     | translate }}</span>
                  <span *ngSwitchCase="1">{{ 'DEVICE_DETAIL.TYPE.MAX'     | translate }}</span>
                  <span *ngSwitchCase="3">{{ 'DEVICE_DETAIL.TYPE.MIN_MAX' | translate }}</span>
                </div>
              </td>
              <td class="mat-cell" [fxLayoutAlign]="'start center'" [fxFlex]="'27%'">
                <mat-form-field>
                  <mat-select [(ngModel)]="alarm.alarmType.value" (selectionChange)="alarm.alarmType.edit = true">
                    <mat-option [value]="0">{{ 'DEVICE_DETAIL.TYPE.NONE'    | translate }}</mat-option>
                    <mat-option [value]="2">{{ 'DEVICE_DETAIL.TYPE.MIN'     | translate }}</mat-option>
                    <mat-option [value]="1">{{ 'DEVICE_DETAIL.TYPE.MAX'     | translate }}</mat-option>
                    <mat-option [value]="3">{{ 'DEVICE_DETAIL.TYPE.MIN_MAX' | translate }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </td>
              <td class="mat-cell" [fxFlex]="'4%'" [fxLayoutAlign]="'start center'">
                <mat-checkbox [(ngModel)]="alarm.alarmType.edit"></mat-checkbox>
              </td>
            </tr>
            <tr class="table-row-content">
              <td class="mat-cell" [fxLayoutAlign]="'start center'"
                  [fxFlex]="'19%'">{{'DEVICE_DETAIL.TAB_ALARM.HYSTERESIS' | translate}}</td>
              <td class="mat-cell" [fxLayoutAlign]="'center center'"
                  [fxFlex]="'27%'">{{alarm.hysteresis.lastUpdateDate | utcDateFormat}}</td>
              <td class="mat-cell" [fxLayoutAlign]="'center center'"
                  [fxFlex]="'27%'">{{alarm.hysteresis.lastValue | number:"1.0-6"}}</td>
              <td class="mat-cell" [fxLayoutAlign]="'start center'" [fxFlex]="'27%'">
                <mat-form-field>
                  <input matInput 
                    [ngModel]="alarm.hysteresis.value | number:'1.0-6'"
                    (ngModelChange)="alarm.hysteresis.value=$event"
                    (change)="alarm.hysteresis.edit = true" 
                    type="number" />
                </mat-form-field>
              </td>
              <td class="mat-cell" [fxFlex]="'4%'" [fxLayoutAlign]="'start center'">
                <mat-checkbox [(ngModel)]="alarm.hysteresis.edit"></mat-checkbox>
              </td>
            </tr>
            <tr class="table-row-content">
              <td class="mat-cell" [fxLayoutAlign]="'start center'"
                  [fxFlex]="'19%'">{{'DEVICE_DETAIL.TAB_ALARM.UPPER' | translate}}</td>
              <td class="mat-cell" [fxLayoutAlign]="'center center'"
                  [fxFlex]="'27%'">{{alarm.upper.lastUpdateDate | utcDateFormat}}</td>
              <td class="mat-cell" [fxLayoutAlign]="'center center'"
                  [fxFlex]="'27%'">{{alarm.upper.lastValue | number:"1.0-6"}}</td>
              <td class="mat-cell" [fxLayoutAlign]="'start center'" [fxFlex]="'27%'">
                <mat-form-field>
                  <input matInput 
                    [ngModel]="alarm.upper.value | number:'1.0-6'"
                    (ngModelChange)="alarm.upper.value=$event"
                    (change)="alarm.upper.edit = true" 
                    type="number"/>
                </mat-form-field>
              </td>
              <td class="mat-cell" [fxFlex]="'4%'" [fxLayoutAlign]="'start center'">
                <mat-checkbox [(ngModel)]="alarm.upper.edit"></mat-checkbox>
              </td>
            </tr>
            <tr class="table-row-content">
              <td class="mat-cell" [fxLayoutAlign]="'start center'"
                  [fxFlex]="'19%'">{{'DEVICE_DETAIL.TAB_ALARM.LOWER' | translate}}</td>
              <td class="mat-cell" [fxLayoutAlign]="'center center'"
                  [fxFlex]="'27%'">{{alarm.lower.lastUpdateDate | utcDateFormat}}</td>
              <td class="mat-cell" [fxLayoutAlign]="'center center'"
                  [fxFlex]="'27%'">{{alarm.lower.lastValue | number:"1.0-6"}}</td>
              <td class="mat-cell" [fxLayoutAlign]="'start center'" [fxFlex]="'27%'">
                <mat-form-field>
                  <input 
                    matInput 
                    [ngModel]="alarm.lower.value | number:'1.0-6'" 
                    (ngModelChange)="alarm.lower.value=$event"
                    (change)="alarm.lower.edit = true"
                    type="number" />
                </mat-form-field>
              </td>
              <td class="mat-cell" [fxFlex]="'4%'" [fxLayoutAlign]="'start center'">
                <mat-checkbox [(ngModel)]="alarm.lower.edit"></mat-checkbox>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
  <mat-card-actions fxLayoutAlign="end center">
    <div style="margin-left: 0; margin-right: auto;">
      <div class="info-message" *ngIf="infoMessage">{{infoMessage}}</div>
      <div class="warning-message" *ngIf="warningMessage">{{warningMessage}}</div>
    </div>
    <button mat-button *ngIf="configuration?.edit" (click)="update()" [disabled]="updating">
      <span *ngIf="!updating" translate>UPDATE</span>
      <mat-progress-spinner *ngIf="updating" mode="indeterminate" [diameter]="25"
                            color="accent"></mat-progress-spinner>
    </button>
    <button mat-button (click)="close()" translate>CLOSE</button>
  </mat-card-actions>
</mat-card-content>
